export default class SCTranslations {
    listTitle;
    newTitle;
    listIsEmpty;
    newTitleNoData;
    constructor({
        listTitle = 'TITLE_LIST',
        listIsEmpty = 'LBL_NO_DATA_FOUND',
        newTitle = 'LBL_NEW_DATA',
        newTitleNoData = 'LBL_NEW_DATA',
    }) {
        this.listTitle = listTitle;
        this.newTitle = newTitle;
        this.listIsEmpty = listIsEmpty;
        this.newTitleNoData = newTitleNoData;
    }
}


// WEBPACK FOOTER //
// ./client/components/simpleCrud/SCTranslations.class.ts